exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner-disabled {\r\n  opacity: 0.6;\n}\n.spinner {\r\n  display: inline-block;\r\n  position: relative;\r\n  cursor: pointer;\n}\n.spinner-button {\r\n  position: absolute;\r\n  right: 0;\r\n  color: #999;\r\n  height: 19px;\r\n  width: 33px;\n}\n.spinner-button-disabled {\r\n  color: #a6a6a6;\r\n  background-color: #ededed;\n}\n.spinner-up {\r\n  top: 0;\n}\n.spinner-down {\r\n  bottom: 0;\n}\n.spinner-icon-up {\r\n  position: relative;\r\n  top: 2px;\r\n  left: 5;\n}\n.spinner-icon-down {\r\n  color: #999;\r\n  position: relative;\r\n  top: -2px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42db20d4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/portal/Order/OrderComponent/RxInput.vue
// module id = 337
// module chunks = 4